/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTrashEmpty: {
  name: 'trash-empty';
  data: string;
} = {
  name: 'trash-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.5a.5.5 0 0 0-.5.5v1.5h3V2a.5.5 0 0 0-.5-.5H7Zm-4 2h2.5V2A1.5 1.5 0 0 1 7 .5h2A1.5 1.5 0 0 1 10.5 2v1.5H15a.5.5 0 0 1 0 1h-1.5V14a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 14V4.5H1a.5.5 0 0 1 0-1h2Zm.5 1V14a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V4.5h-9Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
